import { EntityTypeEnum } from '../../enums/entity-type.enum';
import { ICustodyDTOOut } from '../../interfaces/garde.interface';
import { IAdminDTOOut } from '../../interfaces/users/administrator.interface';
import { IContactDTOOut } from '../../interfaces/users/contact.interface';
import { IEmployeeDTOOut } from '../../interfaces/users/employee.interface';
import { IParentDTOOut } from '../../interfaces/users/parent.interface';
import { IRelativeDTOOut } from '../../interfaces/users/relative.interface';
import { IStudentDTOOut } from '../../interfaces/users/student.interface';
import { IMyUserDTOOut } from '../../interfaces/users/user.interface';

export class GetAllUsersLight {
    public static readonly type = '[Users] get all users light';
    constructor(public forceRefresh: boolean = false) {}
}
export class GetAllUsers {
    public static readonly type = '[Users] get all';
}

export class GetAllEmployees {
    public static readonly type = '[Employees] get all';
}

export class GetAllParents {
    public static readonly type = '[Parents] get all';
}

export class GetAllStudents {
    public static readonly type = '[Students] get all';
}

export class GetAllContacts {
    public static readonly type = '[Contacts] get all';
}

export class GetUserRelatives {
    public static readonly type = '[User Relatives] get';
}

export class GetSortedStudentNursery {
    public static readonly type = '[User Sorted Student Nursery] get';
}

export class GetUserById {
    public static readonly type = '[User] get one';
    constructor(public id: number, public userType: EntityTypeEnum, public forRepertoire: boolean) {}
}

export class DeleteUserToEdit {
    public static readonly type = '[User to edit] delete';
}

export class CreateNewEmployee {
    public static readonly type = '[Employee] create new';
    constructor(public newEmployee: IEmployeeDTOOut) {}
}

export class CreateNewAdministrator {
    public static readonly type = '[Administrator] create new';
    constructor(public newAdministrator: IAdminDTOOut) {}
}

export class CreateNewParent {
    public static readonly type = '[Parent] create new';
    constructor(public newParent: IParentDTOOut) {}
}

export class CreateNewStudent {
    public static readonly type = '[Student] create new';
    constructor(public newStudent: IStudentDTOOut) {}
}

export class CreateNewRelative {
    public static readonly type = '[Relative] create new';
    constructor(public newRelative: IRelativeDTOOut) {}
}

export class CreateNewContact {
    public static readonly type = '[Contact] create new';
    constructor(public newContact: IContactDTOOut) {}
}

export class PatchMyAccount {
    public static readonly type = '[User] my account patch';
    constructor(public myUser: IMyUserDTOOut, public userType: EntityTypeEnum) {}
}

export class PatchEmployee {
    public static readonly type = '[Employee] patch';
    constructor(public employee: IEmployeeDTOOut) {}
}

export class PatchAdministrator {
    public static readonly type = '[Administrator] patch';
    constructor(public administrator: IAdminDTOOut) {}
}

export class PatchParent {
    public static readonly type = '[Parent] patch';
    constructor(public parent: IParentDTOOut) {}
}

export class PatchStudent {
    public static readonly type = '[Student] patch';
    constructor(public student: IStudentDTOOut) {}
}

export class PatchRelative {
    public static readonly type = '[Relative] patch';
    constructor(public relative: IRelativeDTOOut) {}
}

export class PatchContact {
    public static readonly type = '[Contact] patch';
    constructor(public contact: IContactDTOOut) {}
}

export class DeleteAdministrator {
    public static readonly type = '[Administrator] delete';
    constructor(public administratorId: number) {}
}

export class DeleteEmployee {
    public static readonly type = '[Employee] delete';
    constructor(public employeeId: number) {}
}

export class DeleteParent {
    public static readonly type = '[Parent] delete';
    constructor(public parentId: number) {}
}

export class DeleteStudent {
    public static readonly type = '[Student] delete';
    constructor(public studentId: number) {}
}

export class DeleteRelative {
    public static readonly type = '[Relative] delete';
    constructor(public relativeId: number) {}
}

export class DeleteContact {
    public static readonly type = '[Contact] delete';
    constructor(public contactId: number) {}
}

export class EnableUser {
    public static readonly type = '[User] enable';
    constructor(public userId: number) {}
}

export class DisableUser {
    public static readonly type = '[User] disable';
    constructor(public userId: number) {}
}

export class GetCustodies {
    public static readonly type = '[User] get custodies';
    constructor(public studentId: number) {}
}

export class SaveCustody {
    public static readonly type = '[User] save custody';
    constructor(public custody: ICustodyDTOOut, public studentId?: number) {}
}

export class SetStudentIdOfCurrentWaitingCustody {
    public static readonly type = '[User] set id student of waiting custodies';
    constructor(public studentId: number) {}
}

export class ResetStudentIdOfCurrentWaitingCustody {
    public static readonly type = '[User] reset id student of waiting custodies';
}

export class UpdateCustody {
    public static readonly type = '[User] update custody';
    constructor(public studentId: number, public custodyId: number) {}
}

export class ResetWaitingCustody {
    public static readonly type = '[User] reset waiting custody';
}

export class ResetCustody {
    public static readonly type = '[User] reset custody';
}

export class GetParentInCharge {
    public static readonly type = '[Parent in charge] get';
    constructor(public studentId: number, public date?: string, public period?: string) {}
}

export class DeleteCachedUsers {
    public static readonly type = '[User] reset cached users';
}

export class DeleteUserToView {
    public static readonly type = '[User] reset user to view';
}

export class ResetImpersonatedUser {
    public static readonly type = '[User] ResetImpersonatedUser';
    constructor(public newUserId: number) {}
}

export class SetIsImpersonated {
    public static readonly type = '[User] set is impersonated';
    constructor(public isImpersonated: number) {}
}
